<!-- Flippable card -->
<ng-container *ngIf="flippable">

    <!-- Front -->
    <div class="cb-card-front">
        <ng-content select="[cbCardFront]"></ng-content>
    </div>

    <!-- Back -->
    <div class="cb-card-back">
        <ng-content select="[cbCardBack]"></ng-content>
    </div>

</ng-container>

<!-- Normal card -->
<ng-container *ngIf="!flippable">

    <!-- Content -->
    <ng-content></ng-content>

    <!-- Expansion -->
    <div
        class="cb-card-expansion"
        *ngIf="expanded"
        [@expandCollapse]>
        <ng-content select="[cbCardExpansion]"></ng-content>
    </div>

</ng-container>
